/**
 * サービスページのパララックス効果
 * GSAP ScrollTrigger を使用して滑らかな視差効果を実装
 * 
 * @package LIVMO
 * @version 2.0.0
 */

(function() {
  'use strict';

  
  function initWhenReady() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      setTimeout(initWhenReady, 50);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initParallax);
    } else {
      initParallax();
    }
  }

  function initParallax() {
    const section = document.querySelector('.service-contact');
    const bg = document.querySelector('.service-contact__bg');

    if (!section || !bg) {
      return;
    }

    gsap.to(bg, {
      y: 50,
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top bottom',
        end: 'bottom top',
        scrub: 0.6,
        invalidateOnRefresh: true
      }
    });
      
    }

  // 初期化開始
  initWhenReady();

})();
